import { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { Colors, Theme } from '@app/theme';
import { useParticipantFields } from '@app/api';
import { usePricingColor } from './ColorContext';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    textTransform: 'none',
  },

  icon: {
    fontSize: theme.iconSize.regular,
    marginRight: theme.marginBase,
    color: ({ color }: { color: Colors }) => theme.colorDefinitions[color].std,
  },
  item: {
    ...theme.fonts.caption,
    display: 'flex',
    alignItems: 'center',
    listStyle: 'none',
    marginTop: theme.marginBase,
    color: theme.colors.inkSecondary,
  },
}));

interface Props {
  criteria?: string[];
}

export const OfferCriteriaSubList = ({ criteria }: Props) => {
  const color = usePricingColor();
  const classes = useStyles({ color });
  const { data: participantFields = [] } = useParticipantFields();

  const labelByName = useMemo(() => {
    const res: Record<string, string> = {};
    for (const field of participantFields) {
      res[field.name] = field.range?.label || field.label;

      if (field.labelVariants) {
        Object.assign(res, field.labelVariants);
      }
    }
    return res;
  }, [participantFields]);

  if (!criteria) {
    return null;
  }

  return (
    <ul className={classes.container}>
      {criteria.map((name) => (
        <li className={classes.item}>
          <i className={classNames(classes.icon, 'ri-check-line')} />
          {labelByName[name]}
        </li>
      ))}
    </ul>
  );
};
